export default __webpack_public_path__ + "static/media/horizontalColour.6ec077d2.png";